/*
|--------------------------------------------------------------------------
| Model to validate and submit forms
|--------------------------------------------------------------------------
| 
*/

/**
 * TODO when needed: Validations that can only be done in server, such as unique email in database
 */

define('models/Form',['backbone', 'lodash'], function (Backbone, _) {

    "use strict";

    return Backbone.Model.extend({

        /**
         * Validate model attributes according to the validation config
         * @param  {object}     attrs
         * @return {object}             error message object when attributes are invalid 
         */
        validate: function (attrs) {
            var errors = {},
                valid = true;

            // iterate validations
            _.each(this.validations, function (validation, attrName) {
                // iterate rules
                _.every(validation, function (rule) {
                    // get rule name and arguments
                    var args        = rule.split(/[:,]/),
                        ruleName    = args.shift();

                    // run the test
                    var test = this.testRuleOnFilled(ruleName, attrs[attrName], args);
                    if (typeof test === 'string') {
                        errors[attrName] = test;
                        valid = false;
                    } else {
                        return true;
                    }
                }, this);
            }, this);

            // output error messages
            if (!valid) {
                return errors;
            }
        },

        /**
         * Wrapper function of testRule that return true if value is empty, except for the required rule
         * @param  {string}             ruleName
         * @param  {string|number}      value
         * @param  {array}              args
         * @return {boolean|object}                 true or error message object
         */
        testRuleOnFilled: function (ruleName, value, args) {
            if (ruleName !== 'required' && this.testRule('required', value) !== true) {
                return true;
            } else {
                return this.testRule(ruleName, value, args);
            }
        },

        /**
         * Detect and run rules againist value given
         * @param  {string}             ruleName
         * @param  {string|number}      value
         * @param  {array}              args
         * @return {boolean|object}                 true or error message object
         */
        testRule: function (ruleName, value, args) {
            var rule = this.rules[ruleName];
            args = args || [];

            if (typeof rule === 'function') {
                args.unshift(value);
                return rule.apply(this, args);
            } else if (rule instanceof RegExp) {
                // non camelcase ruleName
                var name = ruleName.replace(/([A-Z])/g, ' $1').toLowerCase();

                return rule.test(value) ? true : 'Invalid ' + name;
            }
        },

        /**
         * Validation config
         * @type {Object}
         */
        validations: {
            // examples:
            // email:   ['required', 'email'],
            // zipcode: ['digit:5']
        },

        /**
         * Validation Rules
         * @type {Object}
         * Rules can be in two types: RegExp and function
         * Function rules need to return true when value is valid and error message string when invalid
         * Arguments will be passed to function rules as this:
         * function ruleName (values, [arg0, arg1...]) {}
         */
        rules: {
            required: function (value) {
                return value || value === false || value === 0 ? true : 'Required';
            },
            digit: function (value, length) {
                value = value.toString();
                var isDigits = !/\D/.test(value),
                    matchLength = length ? value.length === length : true;

                return isDigits && matchLength ? true : 'Must be ' + (length || '') + 'digits';
            },

            // For more regex, see: http://www.virtuosimedia.com/dev/php/37-tested-php-perl-and-javascript-regular-expressions
            email: /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
            usStates: /^(?:A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|PA|RI|S[CD]|T[NX]|UT|V[AT]|W[AIVY])*$/i,
            zipCode: /^([0-9]{5}(?: *- *[0-9]{4})?)*$/,
            phoneNumber: /^((([0-9]{1})*[- .(]*([0-9]{3})[- .)]*[0-9]{3}[- .]*[0-9]{4})+)*$/
        }

    });

});
